import {MvsCrudService} from "../../../../../core/shared/service/crud/mvs-crud.service";
import {
    AfterViewInit,
    Component,
    ElementRef,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Renderer2,
    SimpleChanges,
    ViewChild
} from '@angular/core';
import {TicketService} from "../../../service/api/ticket.service";
import {Observable, Subscription} from "rxjs";
// TODO Dependency
// TODO Dependency
import {DmDocumentService} from "../../../../dm/service/api/dm-document.service";
import {QuillHelper} from "../../../../../core/shared/helper/quill-helper";
import {ConfirmationService} from "primeng/api";
import {ContextMenu} from "primeng/contextmenu";
import {ObjectIdentifier} from "../../../../../core/shared/basic/object-identifier";
import {DtoDetail} from "../../../../../core/shared/dto/dto.detail";
import {MvsMessageService} from "../../../../../core/shared/service/message/mvs-message.service";
import {MvsObjectNavigationService} from "../../../../../core/shared/navigation/mvs-object-navigation.service";
import {ObjectTypeService} from "../../../../../core/cc/service/api/object-type.service";
import {MvsObjectService} from "../../../../../core/shared/service/object/mvs-object.service";
import {MvsCoreService} from "../../../../../core/shared/service/mvs-core.service";
import {UmUserService} from "../../../../um/service/api/um-user.service";
import {UiCommentEvent} from "../../../../../core/shared/components/mvs-quill-editor/data/ui-comment-event";
import {ObjectRequestComplex} from "../../../../../core/shared/dto/object/request/object-request-complex";
import {ObjectRequestComplexNode} from "../../../../../core/shared/dto/object/request/object-request-complex-node";
import {ObjectRequestRelation} from "../../../../../core/shared/dto/object/request/object-request-relation";
import {
    ObjectRequestComplexRelationBindingEnum
} from "../../../../../core/shared/dto/object/request/object-request-complex-relation-binding.enum";
import {ObjectRequestList} from "../../../../../core/shared/dto/object/request/object-request-list";
import {FilterCriteria} from "../../../../../core/shared/filter/api/filter.criteria";
import {DtoList} from "../../../../../core/shared/dto/dto.list";
import {UiPageVisitResponseDto} from "../../../../../core/ui/model/dto/entity/ui-page-visit-response.dto";
import {MvsObjectNavigationEntry} from "../../../../../core/shared/navigation/mvs-object-navigation-entry";
import {MvsObjectNavigationActionEnum} from "../../../../../core/shared/navigation/mvs-object-navigation-action-enum";
import {MvsFormDto} from "../../../../../core/shared/dto/form/dto/mvs-form.dto";

//TODO: We are not using LABELS as KEYS!!!
export enum CommentHistoryEnum {
    'All Activity' = 1,
    'Comment',
    'History'
}

@Component({
    selector: 'mvs-ticket-history',
    templateUrl: './ticket-comment-history.component.html',
    styleUrls: ['./ticket-comment-history.component.scss'],
    standalone: false
})
export class TicketHistoryComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit {

    ticketCommentService: MvsCrudService;
    busy: boolean;  // indicator whether the component is busy
    initialized: boolean; // indicator whether the component was initialized
    @Input() objectIdentifier: ObjectIdentifier;
    @Input() documentTypeId: number;
    @Input() euVisible: boolean = false;
    @Input() selectedAction: CommentHistoryEnum = CommentHistoryEnum["All Activity"];
    @Input() highlightCommentId: number;
    historyList: DtoDetail[] = [];
    objectChangeSubscription: Subscription;
    first = 0;
    rows = 5;
    enumCommentHistory = CommentHistoryEnum;
    ticketObjectTypeId: number;
    selectedObject: DtoDetail;
    selectedComment: DtoDetail;
    contextMenuItems: any[];
    hoveredCommentId: number | null = null;
    currentUserId: string = '';
    editingItem: DtoDetail | null = null;
    // TM-1000001438: Enum labels resolved from backend metadata
    actionStatusLabels: Map<number, string> = new Map();
    ticketStatusLabels: Map<number, string> = new Map();

    @ViewChild("cm1") contextMenu!: ContextMenu;


    constructor(protected ticketService: TicketService,
                protected documentService: DmDocumentService,
                protected messageService: MvsMessageService,
                private renderer: Renderer2, private el: ElementRef,
                protected navigationService: MvsObjectNavigationService,
                protected objectTypeService: ObjectTypeService,
                protected objectService: MvsObjectService,
                protected confirmationService: ConfirmationService,
                protected coreService: MvsCoreService) {
    }

    async ngOnInit() {
        this.ticketCommentService = this.coreService.getCrudService("tm.TicketComment");


        await this.initComponent();
        this.refreshComponent();
    }

    /**
     * Initialize Component.
     */
    async initComponent() {
        await this.objectTypeService.getViaObjectType('tm.Ticket').then(res => {
            this.ticketObjectTypeId = res.id;
        });

        this.initCurrentUser();

        this.objectChangeSubscription = this.objectService.objectChangeEvent.subscribe(change => {
            if (change.objectType == "tm.TicketAction" || change.objectType == "tm.Ticket") {
                this.refreshComponent();
            }
        });
    }

    /**
     * Refresh Component.
     */
    refreshComponent() {
        this.refreshHistory();
        // this.initialized = true;
    }

    /**
     * refresh comments and actions and sort them
     */
    refreshHistory() {

        const complexSelection =
            ObjectRequestComplex.build(true, false,
                ObjectRequestComplexNode.createRelationNode("comments",
                    ObjectRequestRelation.createList(
                        "tm.TicketComment",
                        "ticket",
                        null,
                        null,
                        ObjectRequestComplexRelationBindingEnum.ALL)
                ),
                ObjectRequestComplexNode.createRelationNode("commentsEu",
                    ObjectRequestRelation.createList(
                        "tm.TicketCommentEu",
                        "ticket",
                        null,
                        null,
                        ObjectRequestComplexRelationBindingEnum.ALL)
                ),
                ObjectRequestComplexNode.createRelationNode("actions",
                    ObjectRequestRelation.createList(
                        "tm.TicketAction",
                        "ticket",
                        null,
                        null,
                        ObjectRequestComplexRelationBindingEnum.ALL)
                ),
                ObjectRequestComplexNode.createRelationNode("actionStatusHistory",
                    ObjectRequestRelation.createList(
                        "tm.TicketActionStatusHistory",
                        "ticket",
                        null,
                        null,
                        ObjectRequestComplexRelationBindingEnum.ALL)
                ),
                ObjectRequestComplexNode.createRelationNode("statusHistory",
                    ObjectRequestRelation.createList(
                        "tm.TicketStatusHistory",
                        "ticket",
                        null,
                        null,
                        ObjectRequestComplexRelationBindingEnum.ALL)
                )
            );

        // TM-1000001438: includeTemplate=true to get enum metadata for action status labels
        const objectRequestList = ObjectRequestList.createComplexRequestList(
            true,
            complexSelection,
            [FilterCriteria.create("id", FilterCriteria.cOperatorEqual, this.objectIdentifier.objectId)],
            null,
            null,
            null
        );

        // const visitObjectRequest = new ObjectRequestList(false,
        //     [
        //         FilterCriteria.create('objectId', FilterCriteria.cOperatorEqual, this.objectIdentifier.objectId),
        //         FilterCriteria.create('objectType', FilterCriteria.cOperatorEqual, this.ticketObjectTypeId),
        //     ],
        //     []
        // );

        this.ticketService.list(objectRequestList).subscribe(res => {
            this.historyList = [];
            this.postProcessTicketData(res);
            this.sortEntries();
            this.scrollToHighlightedComment();
        });

        // forkJoin({
        //     ticketData: this.ticketService.list(objectRequestList),
        //     visitData: this.uiPageUserService.list(visitObjectRequest)
        // }).subscribe({
        //     next: ({ ticketData, visitData }) => {
        //        this.postProcessTicketData(ticketData);
        //        // this.postProcessVisitData(visitData);
        //        this.sortEntries();
        //
        //     }
        // });
    }

    postProcessVisitData(visitData: DtoList<UiPageVisitResponseDto>) {
        if (!visitData || !visitData.entries.length) {
            return;
        }

        for (let item of visitData.entries) {
            const dto = new DtoDetail();
            dto.createdDate = item.visitedAt;
            dto.lastModifiedDate = item.visitedAt;
            dto.createdBy = item.user;
            dto['uiType'] = 'visit';

            this.historyList.push(dto);
        }
    }
    postProcessTicketData(ticketData: DtoList<DtoDetail>) {
        // TM-1000001438: Resolve action status enum labels from form metadata
        this.resolveActionStatusLabelsFromForm(ticketData.form);
        this.resolveTicketStatusLabelsFromForm(ticketData.form);
        // Process the first API call response
        const ticket = ticketData.entries[0];
        if (ticket['comments']) {
            ticket['comments'].forEach(element => {
                    if (element['entityStatus'] === 5) return;
                    element['uiComment'] = '';
                    element["uiType"] = "comment";
                    this.historyList.push(element);
                    this.processString(element['comment']).subscribe((updatedComment) => {
                        element['uiComment'] = this.collapseBlankLines(updatedComment);
                });
                }
            )
        }

        if (ticket['actions']) {
            ticket['actions'].forEach(element => {
                    if (element['entityStatus'] === 5) return;
                    element["uiType"] = "action";
                    this.historyList.push(element);
                }
            )
        }

        if (ticket['commentsEu']) {
            for (let item of ticket['commentsEu']) {
                if (item['entityStatus'] === 5) continue;
                item["uiType"] = "commentEu";
                item['uiComment'] = this.collapseBlankLines(item['comment']);
                item["commentType"] = "euUser";
                this.historyList.push(item);
            }
        }

        if (ticket['actionStatusHistory']) {
            // TM-1000001438: Build action name map from ticket actions for cross-referencing
            const actionNameMap = new Map<number, string>();
            if (ticket['actions']) {
                for (const action of ticket['actions']) {
                    if (action['id'] && action['ticketTypeActionDtoName']) {
                        actionNameMap.set(action['id'], action['ticketTypeActionDtoName']);
                    }
                }
            }

            for (let item of ticket['actionStatusHistory']) {
                if (item['entityStatus'] === 5) continue;
                item["uiType"] = "actionStatusChange";
                // TM-1000001438: Resolve action name from cross-reference if not set by backend
                if (!item['actionName'] && item['ticketActionDtoId']) {
                    item['actionName'] = actionNameMap.get(item['ticketActionDtoId']) || '';
                }
                this.historyList.push(item);
            }
        }

        if (ticket['statusHistory']) {
            for (let item of ticket['statusHistory']) {
                if (item['entityStatus'] === 5) continue;
                item["uiType"] = "statusChange";
                this.historyList.push(item);
            }
        }

        this.initialized = true;
    }

    /**
     * Collapse consecutive blank lines in HTML content from the rich text editor.
     * Replaces multiple consecutive empty paragraphs with a single line break.
     */
    collapseBlankLines(html: string): string {
        if (!html) return html;
        // Collapse consecutive empty paragraphs (Enter key)
        let result = html.replace(/(<p>(\s|<br>|&nbsp;)*<\/p>\s*){2,}/gi, '<p><br></p>');
        // Collapse consecutive <br> tags within a paragraph (Shift+Enter)
        result = result.replace(/(<br\s*\/?\s*>\s*){2,}/gi, '<br>');
        return result;
    }

    sortEntries() {
        this.historyList.sort((a, b) => {
            const dateA: any = new Date(a.createdDate);
            const dateB: any = new Date(b.createdDate);

            return dateB - dateA;

        });
    }

    processString(content: string): Observable<string> {
        return QuillHelper.resolveDocumentIdImages(content, this.documentService);
    }

    /**
     * Process changes within Binding.
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {

        if (!this.initialized) {
            return;
        }

        if (changes["objectIdentifier"] || changes["documentTypeId"] || changes["euVisible"] || changes["selectedAction"]) {
            this.refreshComponent();
        }

        if (changes["highlightCommentId"] && this.highlightCommentId) {
            this.scrollToHighlightedComment();
        }
    }


    ngAfterViewInit() {
        const commentsContainer = this.el.nativeElement;
        this.renderer.listen(commentsContainer, 'click', (event: MouseEvent) => {
            const target = event.target as HTMLElement;
            if (target.tagName === 'A') {
                event.preventDefault();
                const href = target.getAttribute('href');
                const path = href?.split('&');
                const documentId = path[1]?.split('=')[1];
                this.openDocumentDrawer(+documentId);
            } else if (target.tagName === 'IMG') {
                event.preventDefault();
                const href = target.getAttribute('src');
                const path = href?.split('&');
                const documentId = path[2]?.split('=')[1];
                if (!documentId) {
                    return;
                }
                this.openDocumentDrawer(+documentId);
            }
        });
    }

    openDocumentDrawer(documentId: number) {
        if (!documentId) {
            return;
        }

        // open document in left sidebar
        const mvsObjectNavigationEntry = MvsObjectNavigationEntry.createNavigationEntry(
            "dm.DmDocument",
            documentId,
            'object',
            "Dokument",
            null,
            null,
            MvsObjectNavigationActionEnum.any,
            'side');

        this.navigationService.navigateTo(mvsObjectNavigationEntry, "left");
    }

    startEdit(item: DtoDetail) {
        if (!this.canEditComment(item)) {
            return;
        }
        this.editingItem = item;
    }

    cancelEdit() {
        this.editingItem = null;
    }

    isEditingComment(item: DtoDetail): boolean {
        return this.editingItem?.id === item?.id;
    }

    handleUpdateComment(event: UiCommentEvent) {
        if (this.busy || !this.editingItem) {
            return;
        }

        this.busy = true;

        const dto = new DtoDetail();
        dto.id = this.editingItem.id;
        dto['comment'] = event.comment;

        this.ticketCommentService.update(dto).subscribe(value => {
            this.editingItem = null;
            this.refreshHistory();
            this.busy = false;
            this.messageService.showSuccessMessage("Ticket", "Kommentar aktualisiert");
        }, error => {
            this.busy = false;
            this.messageService.showErrorMessage("Ticket", "Fehler beim Aktualisieren");
        });
    }

    handleDeleteComment(item: DtoDetail) {
        if (!this.canEditComment(item)) {
            return;
        }

        this.confirmationService.confirm({
            message: 'Kommentar löschen?',
            header: 'Kommentar löschen',
            icon: 'pi pi-trash',
            acceptIcon: 'none',
            rejectIcon: 'none',
            rejectButtonStyleClass: 'p-button-text',
            accept: () => {
                this.deleteComment(item);
            }
        });
    }

    private deleteComment(item: DtoDetail) {
        if (this.busy) {
            return;
        }

        this.busy = true;
        this.ticketCommentService.deleteSoft(item.id).subscribe({
            next: () => {
                this.busy = false;
                this.refreshHistory();
            },
            error: (err) => {
                this.busy = false;
                this.messageService.showErrorMessage("Ticket", "Fehler beim Löschen");
            }
        });
    }

    prepareContextMenu(event: MouseEvent, item: DtoDetail) {
        this.contextMenuItems = [];
        if (!this.euVisible || item["commentType"] == "euUser") {
            return;
        }
        event.preventDefault();
        this.selectedComment = item;

        const euVisible = item['euVisible'];
        let contextMenuItem: any;
        if (euVisible) {
            contextMenuItem =  {
                label: 'Remove From EndUser',
                icon: 'pi pi-times',
                display: true,
                command: () => this.handleEuVisible(false)
            }
        } else {
            contextMenuItem =  {
                label: 'Add to EndUser',
                icon: 'pi pi-check-circle',
                display: true,
                command: () => this.handleEuVisible(true)
            }

        }
        this.contextMenuItems.push(contextMenuItem);
        this.contextMenu.toggle(event);
    }

    handleEuVisible(euVisible: boolean) {
        const dto = new DtoDetail();
        dto.id = this.selectedComment.id;
        dto['euVisible'] = euVisible;

        this.ticketCommentService.update(dto).subscribe(value => {

            this.refreshHistory();
            this.busy = false;
            this.messageService.showSuccessMessage("", "Successfully updated end user");
        }, error => {

            this.busy = false;
            this.messageService.showErrorMessage("Comment", "Error occured");
        })

    }

    handleContextMenuHide() {
        this.selectedComment = null;
    }

    /**
     * TM-1000001438: Resolve enum labels from form metadata for a given subForm and field.
     */
    resolveStatusLabelsFromForm(form: MvsFormDto, subFormKey: string, targetMap: Map<number, string>, fieldKey: string = 'previousStatus', fallbackFieldKey: string = 'newStatus') {
        if (!form?.subForms?.[subFormKey]) return;
        const subForm = form.subForms[subFormKey];
        const statusField = subForm?.formFields?.[fieldKey] || subForm?.formFields?.[fallbackFieldKey];
        if (statusField?.valueList?.entries) {
            for (const entry of statusField.valueList.entries) {
                targetMap.set(Number(entry.key), entry.label);
            }
        }
    }

    resolveActionStatusLabelsFromForm(form: MvsFormDto) {
        this.resolveStatusLabelsFromForm(form, 'actionStatusHistory', this.actionStatusLabels);
    }

    resolveTicketStatusLabelsFromForm(form: MvsFormDto) {
        this.resolveStatusLabelsFromForm(form, 'statusHistory', this.ticketStatusLabels);
    }

    /**
     * Get a human-readable label for a TicketActionStatusInternal ordinal.
     */
    getActionStatusLabel(ordinal: number): string {
        return this.actionStatusLabels.get(ordinal) || `Status ${ordinal}`;
    }

    /**
     * Get a human-readable label for a TmStatusEnum ordinal.
     */
    getTicketStatusLabel(ordinal: number): string {
        return this.ticketStatusLabels.get(ordinal) || `Status ${ordinal}`;
    }

    /**
     * Check if a comment was edited (lastModifiedDate > createdDate + threshold).
     */
    isEdited(item: DtoDetail): boolean {
        if (!item?.createdDate || !item?.lastModifiedDate) {
            return false;
        }
        const created = new Date(item.createdDate).getTime();
        const modified = new Date(item.lastModifiedDate).getTime();
        return (modified - created) > 5000;
    }

    private initCurrentUser() {
        const umUserService = this.coreService.getCrudService('um.User') as UmUserService;
        if (umUserService && umUserService.me) {
            umUserService.me().subscribe({
                next: (user) => {
                    this.currentUserId = user?.id?.toString() || '';
                },
                error: () => {
                    this.currentUserId = '';
                }
            });
        }
    }

    private extractUserId(value: any): string {
        if (!value) return '';
        const str = value.toString();
        if (str.includes(':')) {
            const parts = str.split(':');
            return parts.length >= 2 ? parts[1] : str;
        }
        return str;
    }

    canEditComment(item: DtoDetail): boolean {
        if (!item || !this.currentUserId) {
            return false;
        }

        const isOwner = this.extractUserId(item.createdBy) === this.currentUserId;
        if (!isOwner) {
            return false;
        }

        const createdDate = new Date(item.createdDate);
        const now = new Date();
        const hoursDiff = (now.getTime() - createdDate.getTime()) / (1000 * 60 * 60);

        return hoursDiff <= 24;
    }

    getRemainingEditTime(item: DtoDetail): string {
        if (!item?.createdDate) {
            return '';
        }

        const createdDate = new Date(item.createdDate);
        const now = new Date();
        const hoursDiff = (now.getTime() - createdDate.getTime()) / (1000 * 60 * 60);
        const remainingHours = Math.max(0, 24 - hoursDiff);

        if (remainingHours <= 0) {
            return 'Bearbeitungsfenster abgelaufen';
        } else if (remainingHours < 1) {
            const minutes = Math.round(remainingHours * 60);
            return `${minutes}m zum Bearbeiten`;
        } else {
            return `${Math.round(remainingHours)}h zum Bearbeiten`;
        }
    }

    onCommentHover(commentId: number | null) {
        this.hoveredCommentId = commentId;
    }

    copyToClipboard(item: DtoDetail) {
        const text = (item['comment'] || '').replace(/<[^>]*>/g, '');
        navigator.clipboard.writeText(text).then(() => {
            this.messageService.showSuccessMessage('', 'In Zwischenablage kopiert');
        }).catch(err => {
            console.error('Failed to copy comment:', err);
        });
    }

    scrollToHighlightedComment() {
        if (!this.highlightCommentId) {
            return;
        }

        setTimeout(() => {
            const element = this.el.nativeElement.querySelector(`#comment-${this.highlightCommentId}`);
            if (element) {
                element.scrollIntoView({behavior: 'smooth', block: 'center'});
                element.classList.add('comment-highlight');
                setTimeout(() => {
                    element.classList.remove('comment-highlight');
                    this.highlightCommentId = null;
                }, 3000);
            }
        }, 500);
    }

    /**
     * Destroy component.
     */
    ngOnDestroy(): void {
        if (this.objectChangeSubscription) {
            this.objectChangeSubscription.unsubscribe();
        }
    }
}
